module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"paid":{"title":"Pago","description":"Valor total das transações capturadas ou boletos pagos no período. Inclui também boletos pagos a maior.","sales":"cobrança | cobrança | cobranças"}},"en-US":{"paid":{"title":"Paid","description":"Total amount of captured transactions or paid boletos in the period. Also includes overpaid boletos.","sales":"charge | charge | charges"}}}')
  delete Component.options._Ctor
}
